export default () => (
	<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.117 25.938H24.69v3.429h-1.143v-3.429h-3.429v-1.142h3.429v-3.43h1.143v3.43h3.428v1.142z"
			fill="#367BF5"
			stroke="#367BF5"
			stroke-width=".5"
		/>
		<path
			d="m22.557 11.862-8.505 8.505h-3.435v-3.435l8.505-8.52 3.435 3.45zm5.1-1.17c-.015.45-.48.915-.96 1.38l-3.78 3.795-1.305-1.305 3.9-3.885-.885-.885-1.005 1.005-3.435-3.435 3.225-3.225a.905.905 0 0 1 1.29 0l2.145 2.145c.36.33.36.93 0 1.29-.315.315-.615.615-.615.915-.03.3.27.63.57.885.435.45.87.87.855 1.32z"
			fill="#367BF5"
		/>
		<path d="M8.62 19.368c-.504 0-7.503-.501-2.51 4.033 7.007 6.362 2.112 7.037-2.11 3.704" stroke="#367BF5" stroke-width="1.5" />
	</svg>
);
